'use client';

import React from 'react';
import { ButtonShadcn } from '@/components/ui/button-shadcn';
import { useTranslation } from 'react-i18next';
import { PiWarningCircleLight } from 'react-icons/pi';
import samplesSelectorModel from '../Samples/SamplesSelector/SamplesSelectorModel';

/**
 * Full-page error state shown when sample loading fails
 * and there's no valid sample to display (e.g., direct URL to broken sample)
 */
export const SampleLoadError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='fixed inset-0 bg-white flex items-center justify-center p-6' style={{zIndex: 10}}>
      <div className='flex flex-col items-center gap-6 max-w-md text-center'>
        <PiWarningCircleLight size={80} className='text-amber-500' />
        
        <div className='flex flex-col gap-2'>
          <h2 className='text-xl font-semibold text-zinc-900'>
            {t('samples.load_error_dialog.title')}
          </h2>
          <p className='text-sm text-zinc-600'>
            {t('samples.load_error_dialog.description')}
          </p>
        </div>

        <ButtonShadcn
          onClick={() => { samplesSelectorModel.samplesMenuOpen = true; }}
          variant='default'
          size='lg'
          data-testid='sample-error-choose-another-button'
        >
          {t('samples.load_error_dialog.choose_another')}
        </ButtonShadcn>
      </div>
    </div>
  );
};
